//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const VirusScan: FeatureFlag = {"Id":"VirusScan","Label":"Enable virus scanning","Impact":"Files upload to the system are required to pass virus scanning to be successfully upload","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
